import ScrollBooster from 'scrollbooster';

(function($) {
    'use strict';

    if($('.scrollable-table-container').length) {
        var $viewport = document.querySelector('.scrollable-table-container');
        var $content = document.querySelector('.scrollable-table-container .scrollable-table');

        new ScrollBooster({
            viewport: $viewport, // viewport container element, this parameter is required
            content: $content, // scrollable content element
            direction: 'horizontal', // allow only horizontal scrolling
            bounce: false,
            onUpdate: function(state) {
                // only make the content scrollable if the content is wider than the viewport
                if( $content.clientWidth > $viewport.clientWidth ) {
                    $viewport.scrollLeft = state.position.x;
                }
            }
        });
    }

})(jQuery);